<template>
  <div>
    

      <div class="row">
        <h4 class="font-w300 push-10">{{ labelFieldTitle[actualLanguage] }}</h4>
      </div> 

      <spinner size="small" v-if="messageRequestIsSending"></spinner>
      <div v-else>
        <div v-if="actualStatus==='01'" class="row">
          <div class="form-group">
              <div class="col-xs-12">
                <label for="contact-msg">{{labelTextBoxTitle[actualLanguage]}}</label>
                  <div class="form-material form-material-primary">
                      <textarea class="form-control" id="contact-msg" name="contact-msg" rows="7" v-bind:placeholder="labelInFieldMessage[actualLanguage]" v-model="userMessage"></textarea>
                  </div>
              </div>
          </div>
          <div class="form-group">
              <div class="col-xs-12 col-sm-6 col-sm-offset-3">
                  <button class="btn btn-block btn-success" @click=sendSupportRequest() type="submit"><i class="fa fa-send pull-left"></i>{{labelButtonSendMessage[actualLanguage]}}</button>
              </div>
          </div>
        </div>
      </div>

      <div v-if="actualStatus==='MessageTransmitOk'" class="row">
        <label for="contact-msg">{{ messageTransmitOk[actualLanguage] }}</label>
      </div>

      <div v-if="actualStatus==='MessageTransmitFail'" class="row">
        <label for="contact-msg">{{ messageTransmitFail[actualLanguage] }}</label>
      </div>
    
  </div>

</template>


<script>

import {mapState, mapActions} from 'vuex'
import Spinner from '../../components/Spinner.vue'
import _ from 'underscore'
export default {
  name: 'TransmitHelpRequestForm',
  components: {
    Spinner
  },
  data() {
    return {
      errorMsg: '',
      savingCar: false,

      actualStatus : '01',
      messageRequestIsSending : false,
      userMessage : '',

      actualLanguage : "FR",
      labelFieldTitle: {FR: "Demande d'assistance", EN: 'Support request'},
      labelTextBoxTitle: {FR: "Décrire le problème que vous rencontrez.", EN: 'Describe your issue.'},
      labelInFieldMessage: {FR: "Écrire votre message ici..", EN: 'Enter your message here..'},
      labelButtonSendMessage: {FR: "Envoyé le message", EN: 'Send message'},
      messageTransmitOk: {FR: "Message envoyé, le service technique vous contactera sous peu par courriel. Vous pouvez fermer cette fenêtre.", EN: 'Message sent, the technical service will contact you by email. You can close this window.'},
      messageTransmitFail: {FR: "Une erreur de transmission s'est produite. Fermez cette fenêtre et essayez à nouveau.", EN: 'Communication error occurs, close this window and try again.'},
    }
  },


  methods: {

  sendSupportRequest(){
      var requestData = { 'postAction':'SendSupportMessage',
                          'RequestMessage':this.userMessage}
      this.messageRequestIsSending = true
      this.$store.dispatch('sessionStore/postSupport', requestData)
          .then((response) => {
            this.messageRequestIsSending = false
          if(response.data.Code=='OK'){
                  this.actualStatus = 'MessageTransmitOk'
              }
              else
              {
                this.actualStatus = 'MessageTransmitFail'
              }
          })
    },

//this.$store.dispatch('overlayStore/toggleModal',false)

},

created() {
    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}
  }


}

</script>


// WEBPACK FOOTER //
// TransmitHelpRequestForm.vue?48fef191